import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Box,
  Container,
} from "@material-ui/core";
import SettingsContext from "src/context/SettingsContext";
import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import Logo from "./../../component/Logo";
import { BiMoon, BiSun } from "react-icons/bi";
import { AuthContext } from "src/context/Auth";

export default function Header() {
  const auth = useContext(AuthContext);
  const themeSeeting = useContext(SettingsContext);
  const changeTheme = (type) => {
    themeSeeting.saveSettings({
      theme: type,
    });
  };
  const isLightTheme = themeSeeting.settings.theme === "LIGHT";
  const [scroll, setScroll] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const isBlogPage = location.pathname.startsWith("/blog");

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 250);
    });
  }, []);

  useEffect(() => {
    if (isBlogPage && themeSeeting.settings.theme !== "LIGHT") {
      changeTheme("LIGHT");
    }
  }, [isBlogPage, themeSeeting.settings.theme]);

  const displayDesktop = () => {
    return (
      <Toolbar className="NavBar dflexBetween ">
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          {femmecubatorLogo}
        </Box>
      </Toolbar>
    );
  };

  const femmecubatorLogo = (
    <Box>
      <Link to="/">
        <Logo className="logoImg" />
      </Link>
    </Box>
  );


  return (
    <>
      <AppBar
        position={history.location.pathname !== "/" ? "relative" : "absolute"}
        elevation={0}
        className={
          themeSeeting.settings.theme === "DARK"
            ? `${scroll ? "navbar-scroll_dark" : "navbar"}`
            : `${scroll ? "navbar-scroll" : "navbar"}`
        }
        style={{
          backgroundColor: "transparent",
          borderRadius: "0px",
        }}
      >
        <Container maxWidth="lg">{displayDesktop()}</Container>
      </AppBar>
    </>
  );
}
